module.exports = __webpack_public_path__ + "static/media/icon_onboarding_switch.0096a8d5.png";